import React, { useState } from "react";
import { MdMessage } from "react-icons/md";
import { Phone, Mail, MapPin } from "lucide-react";
import image from "../assets/about.png";
import api from "../common/apiClient";
import toast from "react-hot-toast";
import SummaryApi from "../common/SummaryApi";
import { FaWhatsapp } from "react-icons/fa";
import { RotateCcw, ShieldCheck, FileText, Handshake, Headphones } from "lucide-react";
import CommonCTA from "../components/CommonCTA";
const ContactPage = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    interest: "",
    message: "",
    visitorsCount: 1,
    visitorDate: new Date().toISOString().split("T")[0],
  });

  // ✅ CLEAN CHANGE HANDLER
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ SUBMIT WITH API
  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!formData.name) newErrors.name = "Full name is required";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    if (!formData.interest) newErrors.interest = "Please select interest";

    setErrors(newErrors);

    //  stop if error
    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);

      const res =await api({
        url: SummaryApi.createEnquiry.url,
        method: SummaryApi.createEnquiry.method,
        data: formData,
      });
      if (res?.success === true || res?.data?.success === true) {
        toast.success("Requirement submitted successfully");
      }
      // ✅ success clear
      setFormData({
        name: "",
        phone: "",
        email: "",
        interest: "",
        message: "",
        visitorsCount: 1,
        visitorDate: new Date().toISOString().split("T")[0],
      });

      setErrors({});

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">

      {/* HERO */}
      <div className="relative h-[70vh] md:h-[75vh] overflow-hidden">
        <img src={image} alt="hero" className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-black/25 flex flex-col items-center justify-center text-white text-center px-4">
          <h1 className="text-lg md:text-xl">
            Contact KL Property
          </h1>
      <p className="mt-3 text-5xl md:text-6xl font-times">
        Get in Touch with
        <span className="block mt-2">
          KL Property
        </span>
      </p>
        </div>
      </div>

      {/* CONTACT SECTION */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto grid md:grid-cols-[1.3fr_1fr] gap-10 items-center">

          {/* FORM */}
        <div className="bg-white border border-[#45A3010D] p-10 rounded-xl">

          {/* TITLE */}
          <h2 className="font-times text-2xl md:text-3xl mb-8 text-[#2F2F2F]">
            Send Us Your Property Requirement
          </h2>

          {/* INPUTS */}
          <div className="grid md:grid-cols-2 gap-6 mb-6">

            {/* NAME */}
            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Full Name
              </label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Ex.John Doe"
                className={`w-full bg-[#F8FAFC80] border ${
                            errors.name ? "border-red-500" : "border-[#E2E8F0]"
                          } rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]`}
              />
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">{errors.name}</p>
              )}
            </div>

            {/* PHONE */}
            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Phone Number
              </label>
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+91 00000 00000"
                className={`w-full bg-[#F8FAFC80] border ${
                            errors.phone ? "border-red-500" : "border-[#E2E8F0]"
                          } rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]`}
              />
              {errors.phone && (
                <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
              )}
            </div>

          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-6">

            {/* EMAIL */}
            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Email Address
              </label>
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="john@gmail.com"
                className="w-full bg-[#F8FAFC80] border border-[#E2E8F0] placeholder-[#6B7280] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]"
              />
            </div>

            {/* SELECT */}
            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Property Interest
              </label>
              <select
                name="interest"
                value={formData.interest}
                onChange={handleChange}
                className={`w-full bg-[#F8FAFC80] border ${
                            errors.interest ? "border-red-500" : "border-[#E2E8F0]"
                          } rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]`}
              >
                <option value="">Select Category</option>
                <option value="Residential">Residential</option>
                <option value="Commercial">Commercial</option>
                <option value="Plantation">Plantation</option>
                <option value="Home">Home</option>
              </select>
            </div>

          </div>
          <div className="grid md:grid-cols-2 gap-6 mb-6">

            {/* VISITOR COUNT */}
            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Visitors Count
              </label>
              <input
                type="number"
                name="visitorsCount"
                value={formData.visitorsCount}
                onChange={handleChange}
                min="1"
                className="w-full bg-[#F8FAFC80] border border-[#E2E8F0] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]"
              />
            </div>

            {/* VISITOR DATE */}
            <div>
              <label className="text-sm text-[#050505] mb-2 block">
                Visitor Date
              </label>
              <input
                type="date"
                name="visitorDate"
                value={formData.visitorDate}
                onChange={handleChange}
                className="w-full bg-[#F8FAFC80] border border-[#E2E8F0] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]"
              />
            </div>

          </div>
          {/* MESSAGE */}
          <div className="mb-8">
            <label className="text-sm text-[#050505] mb-2 block">
              Your Message
            </label>
            <textarea
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              placeholder="Tell us about your requirements..."
              className="w-full bg-[#F8FAFC80] border border-[#E2E8F0] placeholder-[#6B7280] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#45A301]"
            ></textarea>
          </div>

          {/* BUTTON */}
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-[#45A301] hover:bg-[#3e9202] text-white py-2.5 rounded-lg text-base font-medium transition"
          >
            {loading ? "Submitting..." : "Submit Requirement"}
          </button>

        </div>

          {/* CONTACT INFO */}
          <div className="md:pl-6 flex flex-col justify-center h-full">
            <h2 className="text-[28px] font-times text-[#2F2F2F] mb-10">
              Contact Information
            </h2>

            <div className="space-y-8 text-[15px] text-[#333]">

              {/* Phone */}
              <div className="flex items-start gap-5">
                <div className="bg-[#45A3011A] p-4 rounded-full">
                  <Phone size={20} className="text-[#45A301]" />
                </div>
                <div>
                  <p className="text-[14px] text-black">Phone</p>

                  <a href="tel:+918946059070">
                    <p className="mt-1 text-[17px] font-medium text-[#2F2F2F] hover:text-[#45A301] cursor-pointer">
                      +91 89460 59070
                    </p>
                  </a>
                </div>
              </div>

              {/* WhatsApp */}
              <div className="flex items-start gap-5">
                <div className="bg-[#45A3011A] p-4 rounded-full">
                  <MdMessage size={20} className="text-[#45A301]" />
                </div>
                <div>
                  <p className="text-[14px] text-black">WhatsApp</p>

                  <a
                    href="https://wa.me/918946059070"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="mt-1 text-[17px] font-medium text-[#2F2F2F] hover:text-[#45A301] cursor-pointer">
                      +91 89460 59070
                    </p>
                  </a>

                  <a
                    href="https://wa.me/918946059070"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="bg-white flex items-center gap-2 mt-4 text-[13px] border border-[#43D30033] px-4 py-2 rounded-md text-[#45A301] hover:bg-[#45A3011A] transition">
                      <FaWhatsapp size={20} />
                      <span>Chat on WhatsApp</span>
                    </button>
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-5">
                <div className="bg-[#45A3011A] p-4 rounded-full">
                  <Mail size={20} className="text-[#45A301]" />
                </div>
                <div>
                  <p className="text-[14px] text-black">Email</p>

                  <a href="mailto:klproperity@gmail.com">
                    <p className="mt-1 text-[17px] font-medium text-[#2F2F2F] hover:text-[#45A301] cursor-pointer">
                      klproperity@gmail.com
                    </p>
                  </a>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-5">
                <div className="bg-[#45A3011A] p-4 rounded-full">
                  <MapPin size={20} className="text-[#45A301]" />
                </div>
                <div>
                  <p className="text-[14px] text-black">Address</p>

                  <a
                    href="https://www.google.com/maps?q=Anakkara+Village,+Idukki+District,+Kerala,+India"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  <p className="mt-1 text-[17px] font-medium text-[#2F2F2F] leading-7 max-w-[320px] hover:text-[#45A301] cursor-pointer">
                      Anakkara Village, Idukki District, Kerala, India
                    </p>
                  </a>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>
            <div className="bg-white">

      {/* MAP SECTION */}
      <section className="py-16 flex flex-col items-center">
        {/* Title */}
        <h2 className="text-center text-xl sm:text-2xl font-serif mb-8">
          Visit Our Office
        </h2>

        {/* Map Container */}
        <div className="relative w-full max-w-4xl h-64 sm:h-80 rounded-xl overflow-hidden shadow-lg">
          
          {/* Grayscale Google Map */}
          <iframe
            title="KL Property HQ"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3945.123456789!2d76.758!3d9.967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05e123456789ab%3A0xabcdef123456!2sKL+Property+HQ%2C+Anakkara!5e0!3m2!1sen!2sin!4v1699999999999!5m2!1sen!2sin"
            className="w-full h-full border-0 filter grayscale opacity-70"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

          {/* Centered Info Card */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
                          bg-white rounded-xl shadow-xl p-5 text-center w-56">
            <div className="text-green-600 mb-2">
              {/* Location Icon */}
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" 
                  strokeWidth={2} stroke="currentColor" className="w-6 h-6 mx-auto">
                <path strokeLinecap="round" strokeLinejoin="round" 
                      d="M12 11c1.104 0 2-.896 2-2s-.896-2-2-2-2 .896-2 2 .896 2 2 2z" />
                <path strokeLinecap="round" strokeLinejoin="round" 
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
              </svg>
            </div>
            <p className="font-semibold text-sm sm:text-base">KL Property HQ</p>
            <p className="text-gray-500 text-xs sm:text-sm">Anakkara, Idukki</p>
            <a
              href="https://www.google.com/maps/place/KL+Property+HQ,+Anakkara,+Idukki"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 text-xs sm:text-sm mt-2 font-medium inline-block hover:underline"
            >
              GET DIRECTIONS
            </a>
          </div>

        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4">

          <div className="flex md:grid md:grid-cols-5 gap-6 overflow-x-auto md:overflow-visible scrollbar-hide">

            {/* Item */}
            {[
              { icon: RotateCcw, text: "30+ Years Agriculture Background" },
              { icon: ShieldCheck, text: "Trusted Local Expertise" },
              { icon: FileText, text: "Clear Documentation Support" },
              { icon: Handshake, text: "Transparent Property Deals" },
              { icon: Headphones, text: "Friendly Guidance" },
            ].map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="min-w-[180px] flex flex-col items-center text-center"
                >
                  <div className="bg-white p-6 rounded-full mb-4 shadow-lg flex items-center justify-center">
                    <Icon size={24} className="text-[#45A301]" />
                  </div>
                  <p className="text-sm text-[#334155] leading-5">
                    {item.text}
                  </p>
                </div>
              );
            })}

          </div>

        </div>
      </section>
            </div>

    {/* ================= CTA ================= */}
    <CommonCTA />

    </div>
  );
};

export default ContactPage;